import { useLocation } from 'react-router-dom';
import { useEffect } from 'react';
import ReactPixel from 'react-facebook-pixel';
import PATH from '@/routes/path';

const usePageTracking = () => {
  const location = useLocation();

  // biome-ignore lint/correctness/useExhaustiveDependencies: <explanation>
  useEffect(() => {
    if (location.pathname.indexOf('transaction') === -1 && location.pathname.indexOf('payment') === -1) {
      console.log('recorded pageview', location.pathname);
      ReactPixel.pageView(); // Track page view
    }
  }, [location]);
};

export default usePageTracking;
